/**
 * Константы приложения
 * Централизованное хранение всех магических чисел и настроек
 */

// ==================== КОНСТАНТЫ СИГНАЛИНГА ====================

/** Таймаут открытия WebSocket соединения (мс) */
export const WS_OPEN_TIMEOUT = 8000;

/** Максимальное количество попыток переподключения */
export const MAX_RECONNECT_ATTEMPTS = 10;

/** Интервал отправки ping сообщений (мс) */
export const PING_INTERVAL = 30000;

/** Таймаут ожидания pong ответа (мс) */
export const PONG_TIMEOUT = 10000;

/** Максимальный размер очереди исходящих сообщений */
export const MAX_OUTBOX_SIZE = 100;

// ==================== КОНСТАНТЫ WEBRTC ====================

/** Профили качества видео */
export const QUALITY_PROFILES = {
  '180p': { width: 320, height: 180, frameRate: 15, maxBitrate: 200000 },
  '360p': { width: 640, height: 360, frameRate: 24, maxBitrate: 500000 },
  '480p': { width: 854, height: 480, frameRate: 30, maxBitrate: 1000000 },
  '720p': { width: 1280, height: 720, frameRate: 30, maxBitrate: 2000000 },
  '1080p': { width: 1920, height: 1080, frameRate: 30, maxBitrate: 3000000 }
} as const;

/** Интервал сбора статистики соединения (мс) */
export const STATS_INTERVAL = 2000;

/** Интервал адаптации качества (мс) */
export const QUALITY_ADAPTATION_INTERVAL = 5000;

/** Интервал отправки метрик собеседнику (мс) */
export const METRICS_SEND_INTERVAL = 5000;

/** Таймаут на переподключение после disconnected (мс) */
export const ICE_RESTART_TIMEOUT = 2000;

/** Максимальный битрейт для слабых устройств (bps) */
export const LOW_END_MAX_BITRATE = 1000000;

/** Максимальный битрейт для безопасного режима (bps) */
export const SAFE_MODE_MAX_BITRATE = 500000;

// ==================== КОНСТАНТЫ UI ====================

/** Время отображения уведомления (мс) */
export const NOTIFICATION_DURATION = 3000;

/** Задержка автоскрытия панели управления (мс) */
export const CONTROLS_HIDE_DELAY = 3000;

/** Задержка автоскрытия панели при движении мыши (мс) */
export const CONTROLS_HIDE_DELAY_ON_MOVE = 3000;

/** Задержка автоскрытия панели при уходе мыши (мс) */
export const CONTROLS_HIDE_DELAY_ON_LEAVE = 1000;

/** Задержка автоскрытия панели на мобильных устройствах (мс) */
export const CONTROLS_HIDE_DELAY_MOBILE = 2000;

/** Начальная задержка автоскрытия панели после загрузки (мс) */
export const CONTROLS_INITIAL_HIDE_DELAY = 5000;

/** Задержка перед копированием ссылки (мс) */
export const COPY_FEEDBACK_DURATION = 2000;

// ==================== КОНСТАНТЫ УСТРОЙСТВ ====================

/** Минимальное количество ядер для не-слабого устройства */
export const MIN_CPU_CORES = 4;

/** Минимальная ширина для не-слабого устройства */
export const MIN_DEVICE_WIDTH = 1280;

/** Минимальная высота для не-слабого устройства */
export const MIN_DEVICE_HEIGHT = 720;

/** Минимальный FPS для не-слабого устройства */
export const MIN_DEVICE_FRAMERATE = 24;

/** Максимальное качество для слабых устройств */
export const LOW_END_SUPPORTED_QUALITIES = ['180p', '360p', '480p'] as const;

// ==================== КОНСТАНТЫ АДАПТАЦИИ КАЧЕСТВА ====================

/** Пороги для повышения качества */
export const QUALITY_UPGRADE_THRESHOLDS = {
  /** Обычные устройства */
  normal: {
    rtt: 100,
    packetLoss: 2,
    bitrateOut: 150
  },
  /** Слабые устройства */
  lowEnd: {
    rtt: 50,
    packetLoss: 1,
    bitrateOut: 100
  }
};

/** Пороги для понижения качества */
export const QUALITY_DOWNGRADE_THRESHOLDS = {
  /** Обычные устройства */
  normal: {
    rtt: 300,
    packetLoss: 5
  },
  /** Слабые устройства */
  lowEnd: {
    rtt: 200,
    packetLoss: 3
  }
};

/** Количество последовательных неудач перед понижением качества */
export const CONSECUTIVE_FAILURES_THRESHOLD = 2;

/** Количество проверок перед началом адаптации качества */
export const QUALITY_ADAPTATION_WARMUP = 3;

// ==================== КОНСТАНТЫ СЕТИ ====================

/** Качество для разных типов сети */
export const NETWORK_QUALITY_MAP = {
  'slow-2g': '180p',
  '2g': '180p',
  '3g': '360p',
  '4g': '480p'
} as const;

// ==================== РЕГУЛЯРНЫЕ ВЫРАЖЕНИЯ ====================

/** Определение мобильного устройства по User Agent */
export const MOBILE_REGEX = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

/** Определение типа камеры по label */
export const CAMERA_TYPE_PATTERNS = {
  back: /back|rear|environment/i,
  front: /front|user|face/i
};
